import StatusBadge from '../../Components/Common/StatusBadge';
const Name = cell => {
  return cell.getValue() ? cell.getValue() : '';
};

const CreatedBy = cell => {
  return cell.getValue() ? cell.getValue() : '';
};

const APIKeys = cell => {
  return (
    <input
      type='text'
      className='form-control apikey-value'
      readOnly
      defaultValue={cell.getValue()}
    />
  );
};

const Status = cell => {
  const value = cell.getValue();
  return (
    <StatusBadge
      tone={value === 'Disable' ? 'danger' : 'success'}
      label={value}
    />
  );
};

const CreatedDate = cell => {
  return cell.getValue() ? cell.getValue() : '';
};

const ExpiryDate = cell => {
  return cell.getValue() ? cell.getValue() : '';
};

export { Name, CreatedBy, APIKeys, Status, CreatedDate, ExpiryDate };
